module.exports = __webpack_public_path__ + "fonts/3b7b1fa42e950bc433c5ce018201ff49.txt";